const WORLD_KEYS = {
    SKINCARE: 'skinCare',
    HAIR: 'hair',
    MAKEUP: 'makeup',
    FRAGRANCE: 'fragrance'
};

const WORLD_KEYS_ARRAY = ['fragrance', 'makeup', 'skinCare', 'hair'];

// TODO remove if not needed, we could use these keys to map in our BeautyPreferencesWorlds.ctrlr.jsx component
// and fetch recommendations for each world dynamically

export {
    WORLD_KEYS, WORLD_KEYS_ARRAY
};
